'use strict';

import ExtraFields from './components/ExtraFields.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('extra-fields', ExtraFields);

    }
}
